export const DisableVariationsFeedOptions = {
    ALL: 'all',
    THIS: 'this',
    NONE: 'none',
}
